<template>
<b-container
  class="bg-white py-5 d-flex section"
  fluid
  >
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      
      <b-container class="py-lg-5">
	<b-row class="text-center text-md-left pb-5">
	  <b-col
	    cols="12"
	    md="3"
	    offset-md="1"
	    lg="2"
	    class="order-2 order-md-1"
	    >
	    <slot name="icon">
	      <b-img
		:src="require('../assets/trinapp_files.png')"
		style="height: 114px;"
		/>
	    </slot>
	  </b-col>
	  <b-col
	    cols="12"
	    md="8"
	    lg="9"
	    class="order-1 order-md-2 my-auto headline-wrapper"
	    >
	    <h1 class="font-weight-bold pb-4 pb-md-0">
	      <slot name="header">TrinApp Files</slot>
	    </h1>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col cols="12" md="6" offset-md="1">	
	    <!--div class="d-flex pb-5">
	      <slot name="icon">
		<b-img
		  :src="require('../assets/trinapp_files.png')"
		  class="mr-3"
		  style="height: 114px;"
		  />
	      </slot>
	      <h1 class="font-weight-bold my-auto">
		<slot name="header">TrinApp Files</slot>
	      </h1>
	    </div-->
	    <p class="font-weight-bold mb-4">
	      <slot name="subtitle">File storage built on top of TrinPods with Trinity conceptual AI</slot>
	    </p>
	    <p class="font-italic mb-5">
	      <slot name="description">We think you should have 100% ownership and control over your files and data; who has access, where they are stored, and what apps you use to access them.</slot>
	    </p>      
	  </b-col>
	  <b-col
	    cols="12"
	    md="5"
	    class="text-center"
	    >
	    <slot name="image">
	      <b-img
		:src="require('../assets/TrinPodz_File_Sharing_Image_v4.png')"
		style="max-width: 300px; width: 100%; height: auto;"
		/>
	    </slot>
	  </b-col>
	</b-row>
	<b-row>
	  <b-col>
	    <div class="text-center my-5">
	      <slot name="buttons"></slot>
	    </div>
	  </b-col>
	</b-row>
      </b-container>
      
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "Layout01"
}
</script>

<style scoped>
@media (max-width: 575px) {
	.headline-wrapper > h1 {
		font-size: 2rem !important;
	}
}
</style>
